import React from 'react'
import Pt from 'prop-types'

import { UserRecord } from '../../records'

export default function UserDetails({
  user,
}) {
  if (!user) {
    return null
  }

  return (
    <div className="user-details">
      <strong>{user.first_name} {user.last_name}</strong><br />
      <small className="text-muted">{user.email}</small>
    </div>
  )
}

UserDetails.propTypes = {
  user: Pt.instanceOf(UserRecord),
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/User/UserDetails.jsx